import axios from 'axios';
import { apiVersion1, baseUrl } from 'utils/constant';
const axiosClient = axios.create({
  baseURL: baseUrl + apiVersion1,
  headers: {}
});

axiosClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error.response;
    // if (res.status == 401) {
    //   return (window.location.href = '/session/signin');
    // }
    console.error('Looks like there was a problem. Status Code: ' + res.status);
    return Promise.reject(error);
  }
);

export default axiosClient;
